<template>
  <div class="mb-2 pt-3 pb-2 pb-sm-3" :class="[`${backgroundColor}-card`, { 'px-4': backgroundColor !== 'blue' }]">
    <div class="row align-items-center">
      <slot name="content">
        <div class="col-7 pr-0">
          <div class="mt-2 mb-1 mb-sm-2">
            <b>{{ $t('message.common.getAnswers') }}</b>
          </div>
        </div>
        <div class="col-5 text-center">
          <img src="@/assets/cars.svg" alt="" />
        </div>
      </slot>
    </div>
    <div class="mx-auto chevron-down d-sm-none">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
        <path
          :class="[`${backgroundColor}-fill`]"
          d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GetAnswers',
  props: {
    backgroundColor: {
      type: String,
      default: 'grey',
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';
.grey-card {
  background: rgb(240, 244, 247);
  border-radius: 6px;
  .grey-fill {
    fill: #19222b;
  }
}
.blue-card {
  background: $primary;
  border-radius: 6px;
  color: #ffffff;
  padding-left: 24px;
  padding-right: 0;
  .blue-fill {
    fill: #ffffff;
  }
}
img {
  max-width: 100%;
}
.chevron-down {
  width: 15px;
}
</style>
